export const actionTypes = {
    SHOW_NOTIFICATION: 'SHOW_NOTIFICATION'
}

export const showNotification = ({type, text, timeout}) => ({
  type: actionTypes.SHOW_NOTIFICATION,
  payload: {
    type,
    text,
    timeout
  }
})

export const clearNotification = () => ({
  type: actionTypes.SHOW_NOTIFICATION,
  payload: {
    type: null,
    text: null,
    timeout: null
  }
})